import React from 'react';
import { CheckCircleOutlined, RocketOutlined } from '@ant-design/icons';

export const WelcomeStep: React.FC = () => {
  return (
    <div>
      <p style={{ fontSize: 16 }}>
        Welcome to <strong>Cirra AI</strong>! Let&apos;s get you set up to
        streamline your Salesforce administration with AI.
      </p>

      <p>
        This setup will walk you through connecting your Salesforce organization
        and configuring the MCP (Model Context Protocol) server to work with
        your AI client (such as Claude, ChatGPT, VS Code, or Cursor).
      </p>

      <div className="walkthrough-highlight">
        <div className="walkthrough-highlight-title">
          What you&apos;ll accomplish:
        </div>
        <ul className="walkthrough-feature-list">
          <li>
            <CheckCircleOutlined />
            Connect your Salesforce organization securely
          </li>
          <li>
            <CheckCircleOutlined />
            Set up MCP server integration with your AI client
          </li>
          <li>
            <CheckCircleOutlined />
            <span>
              Supercharge your AI assistant with skills from the{' '}
              <a
                href="https://skills.cirra.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cirra AI Skills Library
              </a>
            </span>
          </li>
          <li>
            <CheckCircleOutlined />
            Start using AI-powered Salesforce administration!
          </li>
        </ul>
      </div>

      <p>
        <RocketOutlined style={{ color: '#1890ff' }} /> Let&apos;s get started!
      </p>
    </div>
  );
};
